import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface Bank {
  bankName: string;
  abbr: string;
}

export interface Enterprise {
  catalog: 'company' | 'biggroup' | 'group';
  city: string;
  companies: number;
  country: string;
  creationDate: Date;
  currency: string;
  currencyTo: string;
  editable: boolean;
  enterpriseId: number;
  enterpriseInfo: string;
  enterpriseName: string;
  group: boolean;
  groupId: number;
  groupName: string;
  industryId: number;
  orgCode: string;
  parentId: number;
  registeredCapital: number;
  registeredCapitalCurrency: string;
  subGroup: boolean;
  totalNum: number;
  valid: boolean;
  localCurrency: string;
  bussinessBoardCataGroup?: any[];
  duration?: { startDate: Date; endDate: Date };
  parent?: { [key: string]: string | number };
  enterpriseEnglishName?: string;
}

export const setEnterprise = createAction('[Enterprise] Set Enterprise Info', props<Enterprise>());
export const mergeEnterprise = createAction('[Enterprise] Merge Enterprise Info', props<Partial<Enterprise>>());
export const resetEnterprise = createAction('[Enterprise] Reset Empty Enterprise');

export function enterpriseReducer(pState: Enterprise | undefined, action: Action) {
  return createReducer(
    {},
    on(setEnterprise, (state, enterprise) => enterprise),
    on(mergeEnterprise, (state, enterprise) => merge({}, state, enterprise)),
    on(resetEnterprise, state => null)
  )(pState, action);
}
